var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-loading"},[_c('FontAwesomeIcon',{staticClass:"mb-2",attrs:{"icon":"spinner","size":"3x","pulse":""}}),_c('h2',{staticClass:"table-loading-title"},[_vm._t("default",function(){return [_vm._v(" Loading... ")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }